import { render, staticRenderFns } from "./EditorDetailsDialog.vue?vue&type=template&id=4e9a2f5c&"
import script from "./EditorDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./EditorDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports